// cookieUtils.js
import CryptoJS from 'crypto-js';
import { Cookies } from 'react-cookie';
import { CookieSetOptions } from 'universal-cookie';
const isProduction = process.env.NODE_ENV === 'production';

const defaultCookieOptions: CookieSetOptions = {
    path: '/',
    maxAge: 3600 * 24, // 
    secure: isProduction, // Ensures cookie is only sent over HTTPS
    sameSite: true, // Helps prevent CSRF
}
const cookies = new Cookies();

// Getter function
export const getSession = (key: string) => {
    if (!cookies.get(key))
        return
    return JSON.parse(cookies.get(key));
};


export const getToken = (key: string) => {
    if (!cookies.get(key, { doNotParse: true }))
        return
    return (cookies.get(key, { doNotParse: true }));
};

// Setter function
export const setSession = (key: string, value: any, options?: CookieSetOptions) => {
    cookies.set(key, JSON.stringify(value), {
        ...defaultCookieOptions,
        ...options
    });
};

export const setToken = (key: string, value: string, options?: CookieSetOptions) => {
    cookies.set(key, (value), {
        ...defaultCookieOptions,
        ...options
    });
};


// Remove function
export const removeSession = (key: string, options?: CookieSetOptions) => {
    // Remove using react-cookie
    cookies.remove(key, {
        ...options,
        path: '/',
        maxAge: 0,
        expires: new Date(0)
    });

    // Force remove using document.cookie
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname};`;
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${window.location.hostname};`;
};

export const getFullPath = (pathname: string, search: string = '') =>
    `${pathname}${search}`;

const REDIRECT_FINGERPRINT_KEY = 'redirectUserFingerprint';

const getRedirectSecret = () =>
    import.meta.env.VITE_APP_REDIRECT_FINGERPRINT_SECRET || import.meta.env.VITE_APP_NAME || 'vachan-redirect';

export const createRedirectFingerprint = (userId: string) =>
    CryptoJS.HmacSHA256(userId, getRedirectSecret()).toString(CryptoJS.enc.Hex);

export const getRedirectFingerprint = () => localStorage.getItem(REDIRECT_FINGERPRINT_KEY) || '';

export const isSameRedirectUser = (storedFingerprint: string, userId: string) =>
    !!storedFingerprint && storedFingerprint === createRedirectFingerprint(userId);

export const setEncodedUrl = (url: string, userId?: string) => {
    try {
        if (!url || url === '/' || !userId) return;
        if (url.indexOf('auth') === -1 && url.indexOf('logout') === -1 && url.indexOf('error') === -1) {
            const encodedUrl = encodeURIComponent(url);
            localStorage.setItem('redirectUrl', encodedUrl);
            localStorage.setItem(REDIRECT_FINGERPRINT_KEY, createRedirectFingerprint(userId));
        }
    } catch (error) {
        console.error(error);
    }
};

export const getDecodedUrl = () => {
    try {
        const encodedUrl = localStorage.getItem("redirectUrl");
        if (encodedUrl) {
            return decodeURIComponent(encodedUrl);
        }
        return '';
    } catch (error) {
        console.error(error);
    }
    return '';
};

export const clearRedirectUrl = () => {
    try {
        localStorage.removeItem('redirectUrl');
        localStorage.removeItem(REDIRECT_FINGERPRINT_KEY);
    } catch (error) {
        console.error(error);
    }
};

// Example usage:
// getCookie('myCookieName');
// setCookie('myCookieName', 'cookieValue', { path: '/', maxAge: 3600 });
